import { useEffect, useRef } from "react";
import { useAuth } from "../contexts/authContext";

// Hides the expired token error as soon as a new token arrives, the user only has to repeat the action
const useClearAuthIssue = (authIssue: boolean, clear: () => void) => {
    const { state: authState } = useAuth();
    const { accessToken } = authState;
    const tokenAtError = useRef<string>();

    useEffect(() => {
        if (authIssue) { tokenAtError.current = accessToken; }
    }, [authIssue]);

    useEffect(() => {
        if (authIssue && accessToken && accessToken !== tokenAtError.current) { clear(); }
    }, [accessToken]);
};

export default useClearAuthIssue;
